// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Vendor protocol the adapter speaks.
 */
export enum AdapterProtocol {
  MCE = 0,
  MODBUS = 1,
  BEAGLE = 2,
  LN1 = 3,
  LN2 = 4,
  DILIGENT = 5,
  BACNET = 6,
  RVU = 7,
  OPC = 8,
  SEQUENT = 9,
  NUMATOGPIO = 10,
  NUMATORELAY = 11,
  STM32 = 12,
  CGA = 13,
  LOBBYVISION = 14,
  CANELEVATOR = 15,
  OPCUA = 16,
  LOBBYVISION2 = 17,
}
